import React, { useLayoutEffect, useRef, useState } from 'react';
import { Col } from 'tea-component';

type TTrendPairRowProps = {
  /** 语言等变化时强制重新订阅尺寸（ResizeObserver 多数情况会自动触发，作双保险） */
  locale?: string;
  left: (syncedToolbarHeight: number) => React.ReactNode;
  right: (toolbarRef: React.RefObject<HTMLDivElement>) => React.ReactNode;
};

/**
 * 同一行内「无 tab」与「有 tab」：测量右侧 Segment 区高度，传给左侧用于加大图表高度，
 * 使左右「标题到图底」总高度一致，且左侧不在标题下留空白条。
 */
const TrendPairRow: React.FC<TTrendPairRowProps> = ({
  locale,
  left,
  right,
}) => {
  const toolbarRef = useRef<HTMLDivElement>(null);
  const [toolbarHeight, setToolbarHeight] = useState(0);

  useLayoutEffect(() => {
    const el = toolbarRef.current;
    if (!el) {
      return;
    }
    const update = (): void => {
      const h = el.getBoundingClientRect().height;
      const rounded = Math.round(h * 100) / 100;
      setToolbarHeight(prev => (prev === rounded ? prev : rounded));
    };
    update();
    const ro = new ResizeObserver(() => {
      update();
    });
    ro.observe(el);
    return () => {
      ro.disconnect();
    };
  }, [locale]);

  // 作为外层 Row 的子节点（与 KeyMetrics 中表格列同级），勿再包一层 Row
  return (
    <>
      <Col span={12} className="dbd-key-metrics-trend-col">
        {left(toolbarHeight)}
      </Col>
      <Col span={12} className="dbd-key-metrics-trend-col">
        {right(toolbarRef)}
      </Col>
    </>
  );
};

export default TrendPairRow;
